module.exports = __webpack_public_path__ + "static/Befragung-Screen-9f85157b6ae18db17011ff5314346dab.png";